<!-- <img src="../../../../../assets/newimg/arrow-1-3@2x.png" [routerLink]="['/permit/approval']" style="cursor: pointer;margin: 10px;"/> -->

<div class="col-md-12" style="margin: 0 auto; width: 100%">
  <!-- <label class="header">Vehicle Details</label>
    <hr> -->
  <span class="pull-right" id="Money" name="Money"
    >Account Balance: {{ appData?.carrier?.account_balance }}</span
  >

  <table class="table">
    <thead>
      <tr>
        <th scope="col">Vehicle Type</th>
        <th scope="col">Reg No.</th>
        <th scope="col">No. Passanger</th>
        <th scope="col">GVM</th>
        <th scope="col">VIN Number</th>
        <th scope="col" style="width: 120px">
          License/Roadworthy C.O.F Expiry Date
        </th>
        <th scope="col" style="width: 200px; text-align: center">Valid From</th>
        <th scope="col" style="text-align: right; width: 200px">
          Application Fee
        </th>
        <th scope="col" style="text-align: right; width: 200px">Permit Fee</th>
        <th scope="col" style="width: 200px; text-align: right">Line Total</th>
        <th scope="col" *ngIf="routeDetials != 'details'">Edit</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of listvehicles; let i = index">
        <td>{{ item.vehicle_type }}</td>
        <td *ngIf="!item.editMode">{{ item.registration_number }}</td>
        <td *ngIf="item.editMode">
          <input
            type="text"
            class="form-control select-input"
            [(ngModel)]="item.registration_number"
          />
        </td>
        <td *ngIf="!item.editMode">{{ item.number_passengers }}</td>
        <td *ngIf="item.editMode">
          <input
            type="number"
            class="form-control select-input"
            [(ngModel)]="item.number_passengers"
          />
        </td>
        <td>{{ item.gvn }}</td>
        <td *ngIf="!item.editMode">{{ item.vin }}</td>
        <td *ngIf="item.editMode">
          <input
            [(ngModel)]="item.vin"
            type="text"
            class="form-control select-input"
          />
        </td>
        <td>{{ item.date_license_expiry }}</td>
        <td style="width: 120px; text-align: center" *ngIf="!item.editMode">
          {{ item.start_date }}
        </td>
        <td style="width: 120px; text-align: center" *ngIf="item.editMode">
          <input
            type="text"
            class="form-control select-input"
            [minDate]="currentDate"
            [(ngModel)]="item.start_date"
            #c{{i}}="ngModel"
            placeholder="dd/mm/yyyy"
            ngbDatepicker
            #d="ngbDatepicker"
            (click)="d.toggle()"
          />
        </td>
        <td style="text-align: right; width: 200px">
          {{ formatCurrency(item.application_fee) }}
        </td>
        <td style="text-align: right; width: 200px">
          {{ formatCurrency(item.permit_fee) }}
        </td>
        <td style="text-align: right; width: 200px">
          {{ formatCurrency(item.lineTotal) }}
        </td>
        <td *ngIf="!item.editMode && routeDetials != 'details'">
          <button
            (click)="editVehicle(item)"
            style="border: none; background-color: white"
          >
            <img src="../../assets/img/border-color-13@2x.png" />
          </button>
        </td>
        <td *ngIf="item.editMode">
          <button
            (click)="saveVehicle(item, i)"
            style="
              border: none;
              background-color: var(--sapphire);
              color: white;
            "
          >
            Save
          </button>
        </td>
      </tr>
      <tr>
        <td colspan="8" style="text-align: right; width: 200px">Total :</td>

        <td>{{ formatCurrency(totalFee) }}</td>
      </tr>
    </tbody>
  </table>
</div>
